import { render } from "./TimesheetPendingActions.vue?vue&type=template&id=c37f1e18&scoped=true"
import script from "./TimesheetPendingActions.vue?vue&type=script&lang=js"
export * from "./TimesheetPendingActions.vue?vue&type=script&lang=js"

import "./TimesheetPendingActions.vue?vue&type=style&index=0&id=c37f1e18&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37f1e18"]])

export default __exports__